<template>
  <v-app class="error-layout">
    <v-main>
      <v-container class="error-container">
        <v-card class="error-card pa-6">
          <v-icon size="42" color="primary">mdi-alert-circle-outline</v-icon>
          <h1>Não foi possível carregar esta página</h1>
          <slot />
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
.error-layout {
  background: var(--funarpen-page);
}

.error-container {
  min-height: 100vh;
  display: grid;
  place-items: center;
}

.error-card {
  width: min(100%, 560px);
  border-left: 5px solid var(--funarpen-gold);
  text-align: center;
}

.error-card h1 {
  margin: 1rem 0;
  color: var(--funarpen-navy);
  font-size: clamp(1.5rem, 3vw, 2rem);
  line-height: 1.2;
}
</style>
